import React from 'react'

export const useChangeBackground = (className: string) => {
  React.useEffect(() => {
    document.body.classList.add(className)

    return () => {
      document.body.classList.remove(className)
    }
  }, [])
}
